import type { SpatialApplication } from '@/types';
import { useEngine } from '@/app/EngineContext';
import { useWorkspaceStore, selectActiveDocument } from '@/store/workspaceStore';
import { addObjectsCommand, nextZIndex } from '@/features/objects/objectCommands';
import { createWindow } from '@/features/objects/objectFactory';
import type { ObjectRendererProps } from './types';
import styles from '../ObjectView.module.css';

/** An application shortcut; double-click opens a window for it beside the icon. */
export const ApplicationRenderer = ({ object: app }: ObjectRendererProps<SpatialApplication>) => {
  const { applications } = useEngine();
  const manifest = applications.get(app.applicationId);
  const launch = () => {
    const ws = useWorkspaceStore.getState();
    const doc = selectActiveDocument(ws);
    if (!doc || !manifest) return;
    ws.dispatch(
      addObjectsCommand([
        createWindow({
          workspaceId: doc.workspace.id,
          position: { x: app.transform.position.x + app.size.width + 24, y: app.transform.position.y },
          zIndex: nextZIndex(doc),
          applicationId: app.applicationId,
          name: manifest.name,
        }),
      ]),
    );
  };
  return (
    <button type="button" className={styles.appTile} onDoubleClick={launch} aria-label={`Launch ${app.name}`}>
      <span className={styles.appGlyph} aria-hidden="true">
        {(manifest?.name ?? app.name).slice(0, 1)}
      </span>
      <strong className={styles.tileTitle}>{manifest?.name ?? app.name}</strong>
    </button>
  );
};
